export default {
	// sections
	NO_EMPLOYMENT_START: 'No-person',
	NO_USER_REFERENCE: 'No-user-reference',
	OTHER: 'Other',
};